import { backendVersion, globalAxios, dineInAxios ,managerInstance} from "@/axios-path.js";
//fetchrewardReport
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    clone_config_path: {
      datetime_start: null,
      datetime_end: null,
      province_id: 0,
      district_id: [0],
    },
    config_path: {
      datetime_start: null,
      datetime_end: null,
      province_id: 0,
      district_id: [0],
    },
    reward_report_summary: {},
    reward_report_list: [],
    export_reward_format: [],
    user_connect_wallet_report: [],
    dineInReport: {
      dineinOrderReport: [
        //   {
        //   order_id: 88,
        //   order_code: "DIHNF5K1UJHR",
        //   order_sale_price: 1200.0,
        //   order_net_price: 1190.0,
        //   order_discount: 10.0,
        //   order_status: 1,
        //   order_payment_type: 2,
        //   order_booking_datetime: "2023-01-10 19:00:00+00:00",
        //   order_send_email: false,
        //   order_note: "",
        //   order_customer_id: 41377,
        //   order_customer_full_name: "Mint Sril",
        //   order_customer_country_tel: "+66",
        //   order_customer_tel: "+66 980121159",
        //   order_store_id: 64,
        //   order_store: {
        //     store_id: 64,
        //     store_name: "กาแฟหรือแกฟ่ะ",
        //     store_addr: "ภูเก็ต",
        //     store_lat: "7.880338324673776",
        //     store_long: "98.39217356819148",
        //     store_tel: "+66936781858",
        //   },
        //   order_is_paymented: 1,
        //   order_payment_charge: "charge_id",
        //   create_by: 41377,
        //   create_at: "2023-01-10T09:07:13.928130Z",
        //   update_by: 41377,
        //   update_at: "2023-01-10T09:07:13.928153Z",
        // }
      ],
    },
    report_dinein:[]
  },
  mutations: {
    resetState(state) {
      state.clone_config_path = {
        datetime_start: null,
        datetime_end: null,
        province_id: 0,
        district_id: [0],
      };
      state.config_path = {
        datetime_start: null,
        datetime_end: null,
        province_id: 0,
        district_id: [0],
      };
      state.reward_report_summary = {};
      state.reward_report_list = [];
      state.export_reward_format = [];
      state.user_connect_wallet_report = [];
    },
    fetchReportList(state, data) {
      state.reward_report_list = data;
      let count_no = 1;
      for (let val of state.reward_report_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getReportSummary(state, data) {
      state.reward_report_summary = {
        total_value_price: 0,
        total_paid_price: 0,
      };
      for (let val of data) {
        state.reward_report_summary.total_paid_price =
          state.reward_report_summary.total_paid_price + val.total_paid_price;
        state.reward_report_summary.total_value_price =
          state.reward_report_summary.total_value_price + val.total_value_price;
      }
    },
    getExportReportForm(state) {
      state.export_reward_format = [];
      for (let val of state.reward_report_list) {
        let index = state.reward_report_list.indexOf(val);
        let push_data = {
          No: index + 1,
          campaign_name: val.campaign_name,
          campaign_service_type: val.campaign_service_type,
          amount: val.amount,
          used: val.used,
          total_value_price: val.total_value_price
            ? parseFloat(val.total_value_price)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          total_paid_price: val.total_paid_price
            ? parseFloat(val.total_paid_price)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
        };
        state.export_reward_format.push(push_data);
      }
    },
    getExportSummaryForm(state) {
      if (state.export_reward_format.length > 0) {
        let push_data = {
          campaign_name: "Total",
          total_value_price: state.reward_report_summary.total_value_price
            ? parseFloat(state.reward_report_summary.total_value_price)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          total_paid_price: state.reward_report_summary.total_paid_price
            ? parseFloat(state.reward_report_summary.total_paid_price)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
        };
        state.export_reward_format.push(push_data);
      }
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
    setConnectWalletReport(state, data) {
      state.user_connect_wallet_report = data.map((val, index) => {
        return { no: index + 1, ...val }
      })
    },
    setDineInReport(state, data) {
      state.dineInReport.dineinOrderReport = data;
    },
    setReportDinein(state,data){
      state.report_dinein = data
    }
  },
  actions: {
    async fetchConnectWalletReport({ commit }) {
      let url = "/api/v1/crypto/getreportwallet";
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.msg === false) return [];
          commit('setConnectWalletReport', res.data)
          return res.data;
        })
        .catch((error) => false);
    },
    async fetchReportList({ rootState, commit, state, dispatch }, config_path) {
      let url =
        backendVersion.version +
        "/all/search/reward_report/0/" +
        config_path.province_id +
        "/datetime_start/datetime_end/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res === false) {
        return [];
      } else {
        commit("fetchReportList", res.data);
        commit("getReportSummary", res.data);
        commit("getExportReportForm");
        commit("getExportSummaryForm");
        commit("cloneConfigPath");
        return res;
      }
    },
    fetchRewardReportByDistrict({ state, dispatch, commit }) {
      let url =
        backendVersion.version +
        "/all/search_by_district/reward_report/0/" +
        state.config_path.province_id +
        "/datetime_start/datetime_end/" +
        state.config_path.datetime_start +
        "/" +
        state.config_path.datetime_end;
      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("fetchReportList", res.data);
          commit("getReportSummary", res.data);
          commit("getExportReportForm");
          commit("getExportSummaryForm");
          commit("cloneConfigPath");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchReportPackages(
      { commit },
      { province_name, package_id, order_status, datetime_start, datetime_end }
    ) {
      let url = `/api/v1/${province_name}/order_report_package/package/order_status/datetime_start/datetime_end/${package_id}/${order_status}/${datetime_start}/${datetime_end}`;
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async fetchReportDineIn(
      { commit },
      { sort_price, page_size, current_page, order_status, datetime_start, datetime_end }
    ) {
      let url = `/api/v1/dine-in/orders/report`;
      let axiosConfig = {
        params: { sort_price, page_size, current_page, order_status, datetime_start, datetime_end },
      };
      return dineInAxios
        .get(url, axiosConfig)
        .then((res) => {
          if (res.msg == false) return false
          commit('setDineInReport', res.data.order)
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async requestedFileReportDineIn(
      { commit },
      { sort_price, page_size, current_page, order_status, datetime_start, datetime_end }
    ) {
      let url = `/api/v1/dine-in/orders/reportManage`;
      let axiosConfig = {
        params: { sort_price, page_size, current_page, order_status, datetime_start, datetime_end },
      };
      return dineInAxios
        .get(url, axiosConfig)
        .then((res) => {
          if (res.msg == false) return false
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
    async getReportDineIn(
      { commit },
      payload
    ) {
      let url = `/api/v1/dine-in/get/report/dine_in?&order_time_start=${payload.datetime_start}&order_time_end=${payload.datetime_end}`;
      return managerInstance
        .get(url,{ params: { store_id: payload.store_id } })
        .then((res) => {
          commit('setReportDinein', res.data)
          return res;
        })
        .catch((err) => {
          return false;
        });
    },
  },
  getters: {},
};
